import React, { useCallback, useContext, useEffect, useState } from 'react';
import { useHistory, Link } from 'react-router-dom';

import PbxContext from '../../../context/PbxContext';

import { accessLocalStorage, valuesAnalyze, changeViewForms, changeIpRoutes, readInterfaces, sendRebootSystem } from '../../../services';
import FormRoutesSet from './formIpSetRoutes';

import '../../../libs/bulma.min.css';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhoneSquare } from '@fortawesome/free-solid-svg-icons';

function RoutesNew() {
  const getItensStateGlobal = useContext(PbxContext);
  const { toggleIsHidden, toggleIsChangeFormElements } = getItensStateGlobal;

  let url = window.location.href;
  url = url.split('/')[2];

  const history = useHistory();

  const [values, setValues] = useState({});
  const [validate, setValidate] = useState({});
  const [disable, setDisable] = useState(true);
  const [disableInput, setDisableInput] = useState(false);
  const [showIfaces, setShowIfaces] = useState([])

  const { changeBorderImputToRedOrNormal, changeVisibityMessages} = changeViewForms;

  const validateUserLogged = useCallback(async () => {
    const dataUser = accessLocalStorage.getUserLocalStorage();
    const { user: { role } } = dataUser;
    if (!dataUser) return history.push('/');
    if (dataUser && role !== 'root') return history.push('/home');
    const getInterfaces = await readInterfaces();
    const interfaces = getInterfaces ? Object.keys(...getInterfaces) : [];
    const filteredInterfaces = interfaces.filter((iface) => !iface.includes('lo'));

    setShowIfaces(filteredInterfaces);
  }, []);

  const changeScreen = (check, name) => {
    changeBorderImputToRedOrNormal(check, name);
    changeVisibityMessages(check, `${name}-invalid-data`);
  };

  const handleChangeDataAnalyze = (name, value) => {
    const { isIP, isMask, isTripleChar } = valuesAnalyze;

    let checkValueIsCharacters = false;
    if (name === 'srdest' || name === 'gw') checkValueIsCharacters = isIP(value);
    if (name === 'mask') checkValueIsCharacters = isMask(value);
    if (name === 'iface') checkValueIsCharacters = isTripleChar(value);
    changeScreen(checkValueIsCharacters, name);
    return checkValueIsCharacters;
  };

  const handleChangeValues = (item) => {
    const { name, value } = item;

    const itemStatus = handleChangeDataAnalyze(name, value);
    
    setValidate((prevState) => prevState, validate[name] = itemStatus === undefined  ? true : itemStatus);

    setValues((prevState) => prevState, values[name] = value);
    if(Object.keys(validate).length%4 === 0) {
      Object.values(validate).includes(false) ? setDisable(true) : setDisable(false);
    } else {
      setDisable(true)
    }
    return;
  };

  const sendDataChangeIpRoutes = async () => {
    const fetchEndpoints = await changeIpRoutes([values]);
    const result = Object.keys(fetchEndpoints).length > 0 ? true : false;
    if(result) {
      changeVisibityMessages(false, 'success-set-routes');
      setDisableInput(true);
      toggleIsHidden('#button-send-form');
      toggleIsHidden('#alert-create-routes');
      toggleIsHidden('#button-send-reboot');
    };
    return;
  };

  const sendRebootSystemPage = async () => {
    await sendRebootSystem();
    history.push('/home');
  };

  useEffect(() => {
    validateUserLogged();
  }, [validateUserLogged]);

  return (
    <div>
      <div className="columns has-text-centered">
        <div className="column is-half is-offset-one-quarter has-text-centered">
          <strong className="is-size-3">ADICIONAR ROTAS</strong>
          <hr className="dropdown-divider"/>
        </div>
      </div>
      <article id="alert-create-routes" name="alert-create-routes" className="column is-half is-offset-one-quarter message is-danger is-hidden">
        <div className="message-header">
          <p>Atenção!</p>
          <button className="delete" aria-label="delete" onClick={ () => {
            toggleIsHidden('#alert-create-routes');
            toggleIsHidden('#button-send-form');
            toggleIsHidden('#button-send-reboot');
            setDisableInput(false);
          }}></button>
        </div>
        <div className="message-body">
          Para as configurações serem aplicadas será efetuado o <strong>reboot</strong> do sistema.
          <br />
          Click no botão <strong>Aplicar</strong> ou feche essa messagem para reiniciar mais tarde.
        </div>
      </article>
      <div name="success-set-routes" className="column is-full is-offset-1 has-text-centered">
        <FormRoutesSet iface={ showIfaces } handleChangeValues={ handleChangeValues } disableInput={ disableInput } />
      </div>
      <div className="columns mx-2">
        <div id="button-send-form" name="button-send-form" className="column mt-3 is-half is-4 is-offset-4 has-text-centered is-active">
            <div className="control">
              <button className="button is-info is-fullwidth" type="submit" disabled={ disable } onClick={ () => sendDataChangeIpRoutes() }>
                <span>
                  Configurar Rota
                </span>
              </button>
            </div>
        </div>
      </div>
      <div className="columns mx-2">
        <div id="button-send-reboot" name="button-send-reboot" className="column mt-3 is-half is-4 is-offset-4 has-text-centered is-hidden">
            <div className="control">
              <button className="button is-warning is-fullwidth" type="submit" onClick={ () => sendRebootSystemPage() }>
                <span>
                  <strong>Aplicar</strong>
                </span>
              </button>
            </div>
        </div>
      </div>
    </div>
  );
}

export default RoutesNew;
